import { useAppSelector } from "@packages/store/hooks";

/**
 * Hook to check if the current user is the author of content
 * @param authorId - The ID of the author to compare with current user
 * @returns Boolean indicating if current user is the author
 */
export function useIsAuthor(authorId: number | undefined): boolean {
  const currentUserId = useAppSelector((state) => state.user.teacher?.id);

  if (!authorId || !currentUserId) {
    return false;
  }

  return currentUserId === authorId;
}

export default useIsAuthor;
